import { formatRange } from "../utils/format";
import "./TimeRangePicker.css";

type TimeRangePickerProps = {
  value: string;
  onChange: (range: string) => void;
  options?: string[];
};

const DEFAULT_OPTIONS = ["6h", "12h", "24h", "7d", "30d", "45d"];

export function TimeRangePicker({
  value,
  onChange,
  options = DEFAULT_OPTIONS,
}: TimeRangePickerProps) {
  return (
    <div class="time-range-picker" role="group" aria-label="Time range">
      {options.map((option) => (
        <button
          key={option}
          type="button"
          class={`time-range-picker__button ${
            option === value ? "time-range-picker__button--active" : ""
          }`}
          aria-pressed={option === value}
          onClick={() => onChange(option)}
        >
          {formatRange(option)}
        </button>
      ))}
    </div>
  );
}
